import React from 'react'
import { Link } from 'react-static'

import { adminCreate } from '../../firebase'

import AdminValidate from './AdminValidate'

export default class AdminCreateListen extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      order: props.data.length,
      title: '',
      url: '',
      titleValid: true,
      urlValid: true
    }
    this.handleFormChange = this.handleFormChange.bind(this)
    this.create = this.create.bind(this)
    this.validate = this.validate.bind(this)
    this.validateAll = this.validateAll.bind(this)
    this.validateForm = this.validateForm.bind(this)
  }

  handleFormChange (e) {
    const name = e.target.name
    const value = e.target.value
    this.setState({[name]: value},
      () => this.validate(name,value))
  }

  validate (name,value) {
    let field = `${name}Valid`
    this.setState({[field]: value.length > 0})
  }

  validateAll () {
    this.setState({
      titleValid: this.state.title.length > 0,
      urlValid: this.state.url.length > 0
    }, this.validateForm)
  }

  validateForm () {
    let formValid = this.state.titleValid && this.state.urlValid
    this.create(formValid)
  }

  create (formValid) {
    if (!formValid) {
      return alert('Complete the highlighted fields')
    }

    const { title, url, order } = this.state
    const id = Date.now()
    let data = {
      title: title,
      url: url,
      order: order
    }
    adminCreate(`listen/${id}`, data, this.props.showSuccessModal, this.props.successRedirect, 'listen')
  }

  render () {
    const { title, titleValid, url, urlValid } = this.state
    const { errorClass } = this.props
    return (
      <div className="column">
        <h3 className="title is-3">Create Post</h3>
        <div className="content">
          <h5 className="title is-5">Title</h5>
          <AdminValidate
            className="field"
            valid={titleValid}
            message="Add a title">
            <div className="control">
              <input className={`input title-input ${errorClass(titleValid)}`}
                type="text"
                value={title}
                name="title"
                onChange={this.handleFormChange}/>
            </div>
          </AdminValidate>
        </div>
        <div className="content">
          <h5 className="title is-5">Embed Link</h5>
          <p>(Paste in embed code from soundcloud, youtube or vimeo)</p>
          <AdminValidate
            className="field"
            valid={urlValid}
            message="Add an embed link">
            <div className="control">
              <input className={`input url-input ${errorClass(urlValid)}`}
                type="text"
                value={url}
                name="url"
                onChange={this.handleFormChange}/>
            </div>
          </AdminValidate>
        </div>
        <div className="field is-grouped">
          <div className="control">
            <button className="button is-success"
              onClick={this.validateAll}>Create</button>
          </div>
          <div className="control">
            <Link to="/admin/listen" className="button is-link"
              >Cancel</Link>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// /opt/build/repo/src/components/admin/AdminCreateListen.js